import { useMutation, useQueryClient } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';
import type { ProspectCadence } from '../types';

export type CadenciaAction =
  | 'start'
  | 'pause'
  | 'resume'
  | 'advance'
  | 'mark_replied'
  | 'mark_meeting'
  | 'mark_dead';

interface CadenciaActionInput {
  empresa_id: string;
  action: CadenciaAction;
  params?: { template?: string; motivo?: string };
}

export function useCadenciaAction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: CadenciaActionInput) => {
      return n8nFetch<ProspectCadence>('/cadencia-action', {
        method: 'POST',
        body: JSON.stringify(input),
      });
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['cadencia', vars.empresa_id] });
    },
  });
}
